import { render, staticRenderFns } from "./ShootingsGallery.vue?vue&type=template&id=ca2fae28&scoped=true"
import script from "./ShootingsGallery.vue?vue&type=script&lang=js"
export * from "./ShootingsGallery.vue?vue&type=script&lang=js"
import style0 from "./ShootingsGallery.vue?vue&type=style&index=0&id=ca2fae28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2fae28",
  null
  
)

export default component.exports